
import Vue from 'vue'

export default Vue.extend({
    name: 'CommonConditionalComponents',
    components: {
        LaunchpadHighlyDrawer: () => import('@/pmd/pages/launchpad/LaunchpadHighlyDrawer.vue'),
    },
    data() {
        return {
            isLaunchpadEnabled: false,
        }
    },
    watch: {
        '$route.params.location_id': async function (id) {
            if(id) {
                await this.isLocationLaunchpadAssigned()
            }
        },
        'companyId': async function (id: string) {
            if(id) {
                await this.checkLaunchpadEnabled()
            }
        }
    },
    methods: {
        async checkLaunchpadEnabled() {
            try {
                if(this.$route?.params?.location_id) {
                    await this.isLocationLaunchpadAssigned()
                } else {
                    await this.isAgencyLaunchpadAssigned()
                }
            } catch(err) {
                //
            }
        },
        async isAgencyLaunchpadAssigned() {
         try {
            await this.$store.dispatch('launchpad/segmentDetailForAgency')
            this.isLaunchpadEnabled = this.$store.state.launchpad.isAgencyLaunchpadAssigned
            const user = this.$store.state.user.user
            // if user is agency user and role is user, `then hide the agency launchpad
            if (user.type === User.TYPE_AGENCY && user.role === User.ROLE_USER) {
                this.isLaunchpadEnabled = false
            }
         } catch(err) {
            //
         } 
        },
        async isLocationLaunchpadAssigned() {
            try {
                const locationId = this.$store.state.locations.currentLocation?.id || this.$route.params.location_id
                if(locationId) {
                    this.isLaunchpadEnabled = await this.$store.dispatch('launchpad/redirectToLaunchpad', locationId)
                }
            } catch(err) {
                //
            }
        }
    },
    computed: {
        launchpadEnabled() {
            return this.isLaunchpadEnabled
        },
        companyId() {
            return this.$store.state?.company?.company?.id
        }
    }
})
